/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-script-url */
import React, { useContext, useEffect, useRef, useState } from 'react'

import { Discussion } from '../../../assets/ts/data/discussions'
import { Inquiry, LIST_NAME } from '../../../assets/ts/data/inquiry/inquiry'
import { formatUTCDateToLocal } from '../../../assets/ts/date-and-time/date-and-time'
import { openFile } from '../../../assets/ts/files/files'
import { defaultToEmptyString } from '../../../assets/ts/formatting/formatting'
import { DocumentIconNames, highlightMatchingText } from '../../../assets/ts/general/general'
import Buttons from '../../../components/buttons/buttons'
import useDueoutDiscussionsMetadata from '../../../hooks/dueout/use-dueout-discussions-metadata'
import useDiscussions from '../../../hooks/use-discussions'
import { UserContext } from '../../../store/user-context-provider'
import { NORESULT } from '../../../utils/constants/rhybus-config'
import InputSearch from '../../../utils/controls/input-search'
import AddDiscussion from './add-discussion'
import './discussions.css'
import Reply from './reply'

const initialValues = ['addDiscussion']
let offsetLeftValue: number
let offsetTopValue: number
let offsetWidthValue: number
let popupTop: number
let xPositionValue: any
interface DiscussionsProps {
  ItemGUID: string
  allFiles: Array[]
  currentInquiry: Inquiry
  hideButton: boolean
  isInquiry: true
  isMenusExpanded?: boolean
  refresh: boolean
  role: any
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>
}
const Discussions = (props: DiscussionsProps) => {
  /** *** Responsive Popup Code Start*****/
  const { multiplePopup, setMultiplePopup } = useContext(UserContext)
  const popupBtnRef = useRef(null)
  const [clicked, setClicked] = useState<string>('0')
  const [xPositionValueUpdate, setXPositionValueUpdate] = useState()

  const [popupHeight, setPopupHeight] = useState<number>()

  const [mainComments, setMainComments] = useState<Discussion[]>([])

  const [refreshFlag, setRefreshFlag] = useState(false)

  const { DiscussionsData, DiscussionsDataIsLoading } = useDiscussions({
    InquiryGUID: props?.ItemGUID,
    refresh: refreshFlag,
  })
  const { DueOutDiscussionsData, dueoutDiscussionsMetadataIsLoading } =
    useDueoutDiscussionsMetadata({
      DueOutGUID: props?.ItemGUID,
      refresh: refreshFlag,
    })
  useEffect(() => {
    props?.setIsLoading(dueoutDiscussionsMetadataIsLoading || DiscussionsDataIsLoading)
  }, [dueoutDiscussionsMetadataIsLoading, DiscussionsDataIsLoading])

  const [discussions, setDiscussions] = useState<Discussion[]>([])
  const [discussionSearch, setDiscussionSearch] = useState<string>('')
  /**
   * Returns the display name of the item's creator if `isCustomer` is false.
   * - If `isCustomer` is true, it returns an empty string.
   * - If `isCustomer` is false, it attempts to return the `firstName` and `lastName` of `ItemCreatedBy` from `item`.
   *
   * @param item - An object that may contain `ItemCreatedBy` with `properties` holding `firstName` and `lastName`.
   * @param isCustomer - A boolean that determines whether to return the name or an empty string.
   * @returns The full name of `ItemCreatedBy` if `isCustomer` is false, otherwise an empty string.
   */
  const handleDisplayNameByRole = (
    item: { ItemCreatedBy?: { properties?: { firstName?: string; lastName?: string } } },
    isCustomer: boolean
  ): string => {
    if (isCustomer && (item.CommentType === 'Customer' || item.CommentType === null)) {
      let role = item?.UserRole?.split(' ').pop()
      role = role === 'Chief'? 'Section Chief': role
      return role
    }
    const firstName = item?.ItemCreatedBy?.properties?.firstName ?? ''
    const lastName = item?.ItemCreatedBy?.properties?.lastName ?? ''
    return `${firstName} ${lastName}`.trim()
  }
  const setDisplayDiscussions = (DiscussionsData) => {
    const mainCommentsData = DiscussionsData?.filter(function (item: Discussion) {
      return !item?.ParentCommentCode
    })
    setMainComments(mainCommentsData)
  }

  function displayChildComment(id: string) {
    const replyComments = discussions?.filter((comment: Discussion) => {
      return comment?.ParentCommentCode == id
    })
    if (replyComments && replyComments.length > 0) {
      return replyComments.map((item: Discussion) => (
        <div
          className={
            clicked == id
              ? 'bgcolor-primary-light p-2 py-1 border-radius'
              : 'bgcolor-primary-light p-2 py-1 border-radius open my-1'
          }
          id={`${id}`}
          key={item?.Id}
          style={{ display: clicked == id ? 'none' : '' }}
        >
          <div
            className='pb-1 sourcesanspro font-13 title-color2 lh-normal'
            dangerouslySetInnerHTML={{
              __html: highlightMatchingText(defaultToEmptyString(item?.Comment), discussionSearch),
            }}
          ></div>
          {item?.CommentDocumentName && displayDocuments(item)}
          <div
            className='subtitle-color1 font-12'
            // dangerouslySetInnerHTML={{
            //   __html: highlightMatchingText(
            //     item?.ItemCreatedBy?.properties?.firstName +
            //       ' ' +
            //       item?.ItemCreatedBy?.properties?.lastName +
            //       ' | ' +
            //       formatUTCDateToLocal(item.ItemCreated, 'date'),
            //     discussionSearch
            //   ),
            // }}
            dangerouslySetInnerHTML={{
              __html: highlightMatchingText(
                `${handleDisplayNameByRole(
                  item,
                  props.role === 'Customer'
                )} | ${formatUTCDateToLocal(item.ItemCreated)}`,
                discussionSearch
              ),
            }}
          ></div>
        </div>
      ))
    }
  }
  function displayDocuments(item: Discussion) {
    const isDeleted = props?.allFiles?.filter((comment) => {
      return comment.fileName === item.CommentDocumentName
    })

    let relativeURl = ''
    props?.allFiles?.filter((comment) => {
      if (comment.fileName === item.CommentDocumentName) {
        relativeURl = comment?.ServerRelativeUrl
      }
    })
    if (item.CommentDocumentName && isDeleted.length > 0) {
      return (
        <div className='color-primary font-14 pb-1'>
          <div className='attachmentsfiles d-flex'>
            <a
              className='attachments py-1 d-inline-block max-fitcontent title-color12 sourcesanspro font-13 me-2 links'
              href='#'
              onClick={() =>
                callFiles(item, props?.allFiles, props?.currentInquiry?.eKey, LIST_NAME)
              }
              title={item.CommentDocumentName}
            >
              <span className={DocumentIconNames(item.CommentDocumentName)}></span>{' '}
              <span
                dangerouslySetInnerHTML={{
                  __html: highlightMatchingText(
                    defaultToEmptyString(item?.CommentDocumentName),
                    discussionSearch
                  ),
                }}
              ></span>
            </a>
          </div>
        </div>
      )
    } else if (item.CommentDocumentName && isDeleted.length === 0) {
      return (
        <div className='color-primary font-14 pb-1'>
          <div className='innerattachments d-flex align-items-center'>
            <ul>
              <li className='list-type-none'>
                <a
                  className='attachments d-flex align-items-center py-1 d-inline-block max-fitcontent title-color12 sourcesanspro font-13 me-2 links'
                  title={defaultToEmptyString(item.CommentDocumentName)}
                >
                  {(props?.allFiles?.length == 0 || props?.allFiles?.length > 0) && (
                    <span
                      aria-label='Deleted'
                      className=' btn btn-border btn-xs font-12 btn-border-radius3 bordered12 p-relative px-2 me-2 title-color39 d-inline-block'
                      tabIndex={0}
                    >
                      Deleted
                    </span>
                  )}
                  <span className={DocumentIconNames(item.CommentDocumentName)}></span>{' '}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: highlightMatchingText(
                        defaultToEmptyString(item?.CommentDocumentName, discussionSearch)
                      ),
                    }}
                  ></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      )
    }
  }
  const handleToggle = (index: string) => {
    if (clicked === index) {
      return setClicked('0')
    }
    setClicked(index)
  }
  function filter(searchWord: string): void {
    const discussionsItem = new Set<Discussion>()
    discussions.forEach((item: Discussion) => {
      const itemDate = formatUTCDateToLocal(item.ItemCreated)
      const createdByNname =
        item?.ItemCreatedBy?.properties?.firstName + ' ' + item?.ItemCreatedBy?.properties?.lastName
      if (
        item?.Comment?.toLocaleLowerCase()?.includes(searchWord) ||
        item?.Subject?.toLocaleLowerCase()?.includes(searchWord) ||
        item?.CommentDocumentName?.toLocaleLowerCase()?.includes(searchWord) ||
        createdByNname.toLocaleLowerCase()?.includes(searchWord) ||
        itemDate?.toLocaleLowerCase()?.includes(searchWord)
      ) {
        discussionsItem.add(item)
        if (item.ParentCommentCode && item.ParentCommentCode !== '') {
          discussions
            ?.filter((parent) => parent.eKey?.toString() === item.ParentCommentCode)
            .map((dis) => {
              discussionsItem.add(dis)
            })
        }
      }
    })
    setDisplayDiscussions([...discussionsItem])
  }
  const getSearch = (event: { target: { value: string } }): void => {
    const searchWord: string = event.target.value.toLocaleLowerCase()
    setDiscussionSearch(searchWord)
    if (searchWord !== '') {
      filter(searchWord)
    } else {
      setDisplayDiscussions(discussions)
    }
  }

  const callFiles = (item, Fileslist, ItemGUID, listName) => {
    const fileDetails = Fileslist?.filter((comment) => {
      return comment.fileName === item.CommentDocumentName
    })
    const file = fileDetails[0]
    openFile(file, ItemGUID, listName)
  }

  useEffect(() => {
    setRefreshFlag(!refreshFlag)
  }, [props?.refresh])

  useEffect(() => {
    const inquiryOrDueOutDiscussions = props.isInquiry ? DiscussionsData : DueOutDiscussionsData
    const filterDiscussion =
      props?.role === 'Customer'
        ? inquiryOrDueOutDiscussions.filter((e) => e.CommentType !== 'Internal')
        : inquiryOrDueOutDiscussions
    setDiscussions(filterDiscussion)
    setDisplayDiscussions(filterDiscussion)
  }, [DiscussionsData, DueOutDiscussionsData])

  useEffect(() => {
    setPopupHeight(window.innerHeight - (offsetTopValue + 65))
    const popupWidthData = popupBtnRef.current ? popupBtnRef.current.offsetWidth : 0
    if (popupWidthData < xPositionValue) {
      xPositionValue = xPositionValue - popupWidthData
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = offsetLeftValue
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = 0
      setXPositionValueUpdate(xPositionValue)
    }
  }, [multiplePopup])
  return (
    <>
      <div className='card-header border-bottom1 d-flex align-items-center p-relative flex-wrap'>
        <div className='d-flex flex-wrap align-items-center'>
          <h2
            aria-label='Discussions'
            className='title-color20 poppins-semibold font-14 mx-1 text-nowrap'
            tabIndex={0}
          >
            Discussions{' '}
            <span className='badge bgcolor-primary font-12 border-radius3 px-2 py-1 whitetext'>
              {defaultToEmptyString(mainComments?.length)}
            </span>
          </h2>
        </div>
        <div className='d-flex align-items-center ms-auto pt-2'>
          {props.hideButton ? (
            discussions?.length > 0 && (
              <InputSearch
                className='no-border form-sm border-radius03 font-13 sourcesanspro'
                icon='icon-search pe-2 title-color2 opacity75'
                inputProps={{
                  arialabel: 'search',
                  placeholder: 'Search',
                }}
                label=''
                onChange={(e: Event) => getSearch(e)}
                searchgroup='bordered2 w-100 d-flex align-items-center border-radius inputswithicon'
              />
            )
          ) : (
            <div className='mx-2 discussionsSearch px-2'>
              {discussions?.length > 0 && (
                <InputSearch
                  className='no-border form-sm border-radius03 font-13 sourcesanspro'
                  icon='icon-search pe-2 title-color2 opacity75'
                  inputProps={{
                    arialabel: 'search',
                    placeholder: 'Search',
                  }}
                  label=''
                  onChange={(e: Event) => getSearch(e)}
                  searchgroup='bordered2 w-100 d-flex align-items-center border-radius inputswithicon'
                />
              )}
            </div>
          )}
          {!props.hideButton && (
            <div>
              <AddDiscussion
                GUID={props?.ItemGUID}
                allFiles={props?.allFiles}
                currentInquiry={props?.currentInquiry}
                isInquiry={props?.isInquiry}
                isMenusExpanded={props?.isMenusExpanded}
                refreshData={() => setRefreshFlag(!refreshFlag)}
                role={props?.role}
              />
            </div>
          )}
        </div>
      </div>
      <div className='card-body'>
        {mainComments?.length === 0 ? (
          <div
            aria-label={NORESULT}
            className='subtitle-color2 montserratregular font-12 text-center py-2 min-h-200 d-flex align-items-center justify-content-around'
            tabIndex={0}
          >
            {NORESULT}
          </div>
        ) : (
          mainComments?.map((items: Discussion) => (
            <div className='mb-2 pb-2 discussionslist' key={items.eTag}>
              <div className=' border-bottom1'>
                <div className='d-flex d-flex align-items-center w-100'>
                  <span
                    aria-label={items.CommentType}
                    className={
                      items.CommentType === 'Customer'
                        ? 'p-1 bgcolor-primary whitetext font-12 poppins-medium border-radius03 me-2'
                        : 'p-1 bgcolor-48 whitetext font-12 poppins-medium border-radius03 me-2'
                    }
                    tabIndex={0}
                  >
                    {defaultToEmptyString(items.CommentType)}
                  </span>
                  <div
                    aria-describedby='discussiontitle'
                    className='color-primary font-12 py-1 poppins-medium maxfitcontent'
                    dangerouslySetInnerHTML={{
                      __html: highlightMatchingText(
                        defaultToEmptyString(items.Subject),
                        discussionSearch
                      ),
                    }}
                    id='discussiontitle'
                    tabIndex={0}
                  ></div>
                </div>
                <div
                  aria-label={items.Comment}
                  className='pb-1 sourcesanspro font-13 title-color2 lh-normal'
                  dangerouslySetInnerHTML={{
                    __html: highlightMatchingText(
                      defaultToEmptyString(items.Comment),
                      discussionSearch
                    ),
                  }}
                  tabIndex={0}
                ></div>
                {(items.CommentDocumentName &&
                  props?.allFiles?.some((comment) => {
                    return comment.fileName === items.CommentDocumentName
                  })) ||
                !items.CommentDocumentName ? (
                  <div className='attachmentsfiles d-flex'>
                    <a
                      className='py-1 d-inline-block max-fitcontent title-color12 sourcesanspro font-13 me-2 links'
                      href='#'
                      onClick={(event) =>
                        callFiles(items, props?.allFiles, props?.currentInquiry?.eKey, LIST_NAME)
                      }
                      title={defaultToEmptyString(items.CommentDocumentName)}
                    >
                      <span className={DocumentIconNames(items.CommentDocumentName)}></span>{' '}
                      {defaultToEmptyString(items.CommentDocumentName)}
                    </a>
                  </div>
                ) : (
                  <div className='attachmentsfiles d-flex'>
                    <p
                      className='py-1 d-inline-block max-fitcontent title-color12 sourcesanspro font-13 me-2 links'
                      title={items.CommentDocumentName}
                    >
                      <span
                        aria-label='Deleted'
                        className='btn-border btn-xs font-12 btn-border-radius3 bordered12 p-relative px-2 me-2 title-color39 d-inline-block'
                        tabIndex={0}
                      >
                        Deleted
                      </span>
                      <span className={DocumentIconNames(items.CommentDocumentName)}></span>{' '}
                      {items.CommentDocumentName}
                    </p>
                  </div>
                )}
                <div
                  aria-describedby='discussioncreatedinfo'
                  className='sourcesanspro subtitle-color2 font-13 maxfitcontent'
                  dangerouslySetInnerHTML={{
                    __html: highlightMatchingText(
                      `${handleDisplayNameByRole(
                        items,
                        props.role === 'Customer'
                      )} | ${formatUTCDateToLocal(items.ItemCreated)}`,
                      discussionSearch
                    ),
                  }}
                  id='discussioncreatedinfo'
                  tabIndex={0}
                ></div>
                <div className='p-relative d-flex align-items-center w-100'>
                  <div className='d-flex align-items-center ms-auto'>
                    <div>
                      <Buttons
                        className={
                          discussions?.filter((comment: Discussion) => {
                            return comment?.ParentCommentCode == items?.eKey
                          }).length > 0
                            ? 'mx-1 btn-sm d-flex align-items-center ms-auto btn-border-radius3 sourcesanspro font-13 title-color'
                            : 'mx-1 btn-sm d-flex align-items-center ms-auto btn-border-radius3 sourcesanspro font-13 title-color d-none'
                        }
                        label={
                          discussions?.filter((comment: Discussion) => {
                            return comment?.ParentCommentCode == items?.eKey
                          }).length > 1
                            ? discussions?.filter((comment: Discussion) => {
                                return comment?.ParentCommentCode == items?.eKey
                              }).length +
                              ' ' +
                              'Reply(s)'
                            : discussions?.filter((comment: Discussion) => {
                                return comment?.ParentCommentCode == items?.eKey
                              }).length + 'Reply'
                        }
                        onClick={() => {
                          handleToggle(items.eKey)
                        }}
                        rIcon={
                          clicked === items?.eKey
                            ? 'icon-dropdown ms-1 font-11 rotate color-primary'
                            : 'icon-dropdown ms-1 font-11 color-primary'
                        }
                        type='button'
                      />
                    </div>
                    {props.hideButton ? null : (
                      <div>
                        <Reply
                          ItemGUID={props?.ItemGUID}
                          allFiles={props?.allFiles}
                          currentInquiry={props?.currentInquiry}
                          discussion={items}
                          id={items?.eKey}
                          isInquiry={props?.isInquiry}
                          refreshData={() => setRefreshFlag(!refreshFlag)}
                          role={props?.role}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {displayChildComment(items?.eKey)}
            </div>
          ))
        )}
      </div>
    </>
  )
}
export default Discussions
